var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 2.08032V5.86665C12.8334 6.38003 12.8334 6.63672 12.9333 6.83281C13.0212 7.00529 13.1614 7.14552 13.3339 7.23341C13.53 7.33332 13.7867 7.33332 14.3001 7.33332H18.0864M8.25008 13.7499L11.0001 16.4999M11.0001 16.4999L13.7501 13.7499M11.0001 16.4999L11.0001 10.9999M12.8334 1.83325H8.06675C6.5266 1.83325 5.75653 1.83325 5.16827 2.13298C4.65083 2.39664 4.23013 2.81733 3.96648 3.33478C3.66675 3.92304 3.66675 4.69311 3.66675 6.23325V15.7666C3.66675 17.3067 3.66675 18.0768 3.96648 18.6651C4.23013 19.1825 4.65083 19.6032 5.16827 19.8669C5.75653 20.1666 6.5266 20.1666 8.06675 20.1666H13.9334C15.4736 20.1666 16.2436 20.1666 16.8319 19.8669C17.3493 19.6032 17.77 19.1825 18.0337 18.6651C18.3334 18.0768 18.3334 17.3067 18.3334 15.7666V7.33325L12.8334 1.83325Z",
    stroke: "#6EAF1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceD);
export default __webpack_public_path__ + "static/media/invoiceD.5e7a0e4c467aeb9529adbac5a2c4ddad.svg";
export { ForwardRef as ReactComponent };